import React from 'react'
import styles from '../containers/launchPage.module.scss'

type LaunchButtonProps = {
  label: string
  onClick?: () => void
  variant?: 'primary' | 'accent' | 'secondary' | 'ghost'
  pulse?: boolean
  className?: string
  showExternalIcon?: boolean
}

export const LaunchButton: React.FC<LaunchButtonProps> = ({
  label,
  onClick,
  variant = 'primary',
  pulse = false,
  className,
  showExternalIcon = false,
}) => {
  const variantClass =
    variant === 'accent'
      ? styles.accentButton
      : variant === 'secondary'
      ? styles.secondaryButton
      : variant === 'ghost'
      ? styles.ghostButton
      : styles.primaryButton

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.launchButton} ${variantClass} ${
        pulse ? styles.pulse : ''
      } ${className ?? ''}`}
    >
      {label}
      {showExternalIcon && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={16}
          height={16}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          style={{
            flexShrink: 0,
            opacity: 0.85,
            display: 'block',
            transform: 'translateY(-1px)',
          }}
        >
          <path d="M15 3h6v6" />
          <path d="M10 14 21 3" />
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        </svg>
      )}
    </button>
  )
}
